import { createQueryKey } from '../query';
import { activationKeys } from './activations/keys';
import { categoriesKeys } from './categories/keys';
import { locationsKeys } from './locations/keys';
import { merchantKeys } from './merchants/keys';

const offerKeys = createQueryKey({
  all: ['offers'] as const,
  categories: categoriesKeys(),
  locations: locationsKeys(),
  merchants: merchantKeys(),
  activations: activationKeys(),
});

export { offerKeys };
